var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("validation-provider", {
    ref: "provider",
    attrs: { rules: _vm.validates, name: _vm.name, immediate: false },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({ errors }) {
          return [
            _c(
              "div",
              {
                staticClass: "form-group",
                class: { "has-errors": errors.length },
                style: { "margin-bottom": _vm.marginBottom },
              },
              [
                _vm.label
                  ? _c("label", { staticClass: "form-control-label" }, [
                      _vm._v(_vm._s(_vm.label)),
                    ])
                  : _vm._e(),
                _c("vue-tel-input", {
                  attrs: {
                    "input-classes": {
                      "form-control": true,
                      "is-invalid": errors.length,
                    },
                    name: _vm.name,
                    placeholder: _vm.placeholder,
                    autofocus: false,
                    disabled: _vm.disabled,
                    autocomplete: "off",
                    "default-country": _vm.defaultCountry,
                    "input-options": { showDialCode: false, tabindex: false },
                    "only-countries": _vm.onlyCountries,
                    "ignored-countries": ["IO", "NR", "SH", "SX", "TK", "WF"],
                    "disabled-fetching-country": _vm.disabledFetchingCountry,
                  },
                  on: {
                    validate: _vm.handleValidate,
                    "country-changed": _vm.handleCountryChanged,
                    input: _vm.handleInput,
                  },
                  model: {
                    value: _vm.phoneNumber,
                    callback: function ($$v) {
                      _vm.phoneNumber = $$v
                    },
                    expression: "phoneNumber",
                  },
                }),
                errors.length
                  ? _c("b-form-invalid-feedback", [
                      _vm._v(" " + _vm._s(errors[0]) + " "),
                    ])
                  : _vm._e(),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }